import { Box, Grid2, Typography } from '@mui/material'
import Heading from '../../shared/utils/Heading'
import CustomDivider from '../../shared/utils/CustomDivider'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';


const HowWorkSection = ({ howWorkData }) => {
    const data = [
        {
            title: "Understands Every Child Individually",
            content: "LATAA evaluates each child’s current level of understanding concept strength, gaps, pace of learning and builds a detailed learning profile.",
            bgColor: "#36BBE4"
        },
        {
            title: "Generates Tailor Made Content",
            content: "Worksheets, lessons, practice exercises, revision tasks, and assessments are all generated specifically for that child’s needs",
            bgColor: "#FD2F7B"
        },
        {
            title: "Aligns with NCERT & Any School Publisher",
            content: "Whether a child follows NCERT or books from any leading publisher, LATAA aligns the entire curriculum to match school expectations",
            bgColor: "#E47C36"
        },
        {
            title: " Integrates ELYF Concept Based Learning",
            content: "The AI ensures children master essential grade-level basics through the ELYF framework making learning simple, strong, and logically structured",
            bgColor: "#9954E2"
        },
        {
            title: "Connects Academics With Skill-Based Camps",
            content: "LATAA blends academic learning with creative, physical, and experiential activities from our skill based programs giving children real-life understanding , not just textbook knowledge.",
            bgColor: "#E27C54"
        },
    ]
    return (
        <Box>
            <Heading Heading={howWorkData?.subheading} SubHeading={howWorkData?.heading} />
            <CustomDivider />
            <Grid2 container spacing={"1rem"} sx={{ display: "flex" }}>

                {
                    howWorkData?.stpesToWork?.map((item, index) => (
                        <Grid2 key={index} size={{ xs: 6, sm: 4, md: 2.4 }} sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", }}>
                            <Box>
                                <Typography variant='h1' color='#C0C0C0' mb={2}>
                                    0{index + 1}
                                </Typography>
                                <Typography variant='body1' color='grey.400' dangerouslySetInnerHTML={{ __html: item?.listItemContent }} />
                                {/* {item?.content}
                                </Typography> */}
                            </Box>



                            <Box
                                sx={{
                                    height: 500,
                                    p: 2,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        flexGrow: 1,
                                        justifyContent: "flex-end",
                                        mb: 1
                                    }}
                                >

                                    <KeyboardArrowUpIcon sx={{ fontSize: 24, color: "red.main" }} />
                                    <Box
                                        sx={{
                                            width: "2px",
                                            height: "100%",
                                            borderLeft: "2px dotted #DC143C",
                                            opacity: 0.4
                                        }}
                                    />


                                </Box>

                                <Box
                                    sx={{
                                        width: "100%",
                                        bgcolor: "#FD2F7B",
                                        boxShadow: "0px 8px 16px 0px #00000040 inset",
                                        height: `${35 + index * 13}%`,
                                        borderRadius: 1,
                                        p: 2
                                    }}
                                >
                                    <Typography variant='h2' color='primary.main' mb={1}>
                                        0{index + 1}
                                    </Typography>
                                    <Typography variant='body1' color='primary.main' dangerouslySetInnerHTML={{ __html: item?.listItemTitle }}/>
                                        {/* {item?.title}
                                    </Typography> */}

                                </Box>
                            </Box>

                        </Grid2>
                    ))
                }

            </Grid2>


        </Box>
    )
}

export default HowWorkSection
